// Origen del catálogo de traducciones: frontend.langsUrlBase de config-business o, si está vacío, vecflow.
export var LANGS_URL_BASE_DEFAULT = 'https://flow.vecfleet.io/api/lang';

export function resolveLangsUrlBase(configBusiness) {
    var frontend = configBusiness && configBusiness.frontend;
    // Sin '/' final: se concatena '/' + locale y un '//es' da 404 tanto en vecflow como en el backend
    return ((frontend && frontend.langsUrlBase) || LANGS_URL_BASE_DEFAULT).replace(/\/+$/, '');
}

// Idioma de arranque: el que eligió el usuario, el default del tenant (frontend.defaultLanguage), el de
// config.json o 'es'. Un valor mal formado ('es_AR') hace que react-intl tire RangeError y la app quede en
// blanco sin poder hacer logout, así que se saltea y se prueba el siguiente.
export function resolveLocale(configBusiness, userLocale, configJsonDefault) {
    var frontend = configBusiness && configBusiness.frontend;
    var candidatos = [userLocale, frontend && frontend.defaultLanguage, configJsonDefault];
    for (var i = 0; i < candidatos.length; i++) {
        var locale = typeof candidatos[i] === 'string' ? candidatos[i].trim() : '';
        if (locale && esLocaleValido(locale)) { return locale; }
    }
    return 'es';
}

function esLocaleValido(locale) {
    try { Intl.getCanonicalLocales(locale); return true; } catch (e) { return false; }
}
